import React from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Box, Button, Portal, Modal, Card, CardContent, CardHeader, CardActions, TextField, Typography, LinearProgress } from '@mui/material';
import { updateOrder } from '../../../../../../services/redux-actions';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const validationSchema = Yup.object({
  name: Yup.string(),
  gross_value: Yup.number().required('To pole nie może być puste')
    .positive('Kwota diety musi być większa od 0')
});


export default function SupplementModal ({ mainFormik, handleClose, orderId, mutate, loading }) {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      name: '',
      gross_value: 0
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      values.name = `Dopłata ${values.name}`;
      const data = {
        positions: [values]
      };
      handleSubmit(data, values);
    }
  });

  const handleSubmit = async (data, values) => {
    const { error, payload } = await mutate(orderId, data);
    if (!error) {
      toast.success('Dopłata została dodana');
      dispatch(updateOrder(payload));
      console.log(mainFormik, values);
      mainFormik.setFieldValue('positions', [...mainFormik.values.positions, values]);
      mainFormik.resetForm({ values: { ...mainFormik.values, positions: payload.products.map(p => ({ ...p, status: 'OLD' })) } });
      handleClose();
    } else {
      toast.error('Wystąpił błąd');
    }
  };

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card style={{ width: '500px', ...style }}>
          <CardHeader title="Dopłata"></CardHeader>
          <CardContent>
            <Box sx={{ position: 'relative', mb: 3 }}>
              <TextField
                id="name"
                label="nazwa"
                onChange={formik.handleChange}
                value={formik.values.name}
                error={formik.errors.name && formik.touched.name}
                helperText={formik.errors.name}
                InputProps={{
                  style: {
                    paddingLeft: '80px'
                  }
                }}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <Typography sx={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: '14px' }}>Dopłata</Typography>
            </Box>
            <TextField
              id="gross_value"
              label="kwota"
              onChange={formik.handleChange}
              value={formik.values.gross_value}
              error={formik.errors.gross_value && formik.touched.gross_value}
              helperText={formik.errors.gross_value}
              type="number"
              fullWidth
            />
          </CardContent>
          <CardActions sx={{ p: 3, pt: 0 }}>
            {loading
              ? <LinearProgress sx={{ width: '100%' }}/>
              : <>
                <Button variant="outlined" fullWidth onClick={handleClose}>Anuluj</Button>
                <Button variant="contained" fullWidth onClick={formik.handleSubmit}>Dodaj</Button>
              </>}

          </CardActions>
        </Card>
      </Modal>
    </Portal>
  );
};
